// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api: {
    baseUrl: 'http://localhost:3000',
  },
  supabase: {
    supabaseUrl: 'https://qxvkowczmqcexpkennco.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF4dmtvd2N6bXFjZXhwa2VubmNvIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTQyNTUwMzcsImV4cCI6MTk2OTgzMTAzN30.D7bUY7heCx7zrYYQnwAzeaHaDGQWEIgKdSdw0plmWhk',
  },
  algolia: {
    appId: 'WGU71GKK0L',
    apiKey: '2b4e3f55d86eac84c63a64e0c0b98b04',
  },
  cubejs: {
    url: 'https://meditech-bi-cubejs.uqfb68.easypanel.host/cubejs-api/v1',
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE3MjY1MjkwNjksImV4cCI6MTg1Mjc1OTQ2OSwiYXVkIjoibWVkaXRlY2hwbWEuY28uemEiLCJzdWIiOiJtdXRvbmRpQGZ1ZWxjYXBwLmNvbSIsIkdpdmVuTmFtZSI6Ik11dG9uZGkiLCJTdXJuYW1lIjoiVHNoaXZoYXNlIiwiRW1haWwiOiJtdXRvbmRpQGZ1ZWxjYXBwLmNvbSIsIlJvbGUiOiJQcm9qZWN0IEFkbWluaXN0cmF0b3IifQ.9SEd3pddSCl7ZVW4-OvDmrIJy0OGXyYsFaWdNEFKB9M',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
